<template>
    <div>
        <navigation-bar Close/>
        <div class="main container">
            <img :src="titleImage">
            <h4 class="mb-3 mt-3">{{title}}</h4>
            <p class="date2">{{ createdAt.slice(0, 16) }}</p>

            <div ref="articleHtmlContentContainer" class="text-content" v-html="content"/>
            <NewsFunction :viewCount="viewCount" :messageCount="messageCount"/>
            <el-divider/>

            <!--TODO 拿主題活動的留言區塊來用要修改-->
            <Message
                     :messageList="messageList"
                     @message-reply="messageReply"
                     @message-confirm="messageConfirm"
                     @messageReplyDelete="messageDelete"
                     @messageConfirmDelete="messageDelete"
                     @messageConfirmReport="messageConfirmReport"
            />

        </div>
        <loading
            :active.sync=isLoading
            :can-cancel="false"
            :is-full-page="true">
        </loading>
    </div>


</template>

<script>
    import NewsFunction from '@/components/NewsFunction.vue'
    import Message from '@/components/Message.vue'
    import * as constDefine from "@/store/constDefine";
    import Form from "@/util/form";

    export default {
        name: 'MarketplaceArticleDetail',
        components: {
            NewsFunction,
            Message,
        },
        data() {
            return {
                dataToken: this.$route.query.dataToken !== undefined ? this.$route.query.dataToken : "",
                // dataObject: {},
                isLoading: false,

                title: '',
                content: '',
                viewCount: 0,
                titleImage: '',
                createdAt: '',
                messageList: [],
                messageCount: 0,

                id: 0,
                code: this.$route.query.code ?? '',
            }
        },
        created() {
            // if (this.dataToken !== "") {
            //     this.initForDataToken(this.dataToken);
            // }
            if (this.code === '') {
                this.$router.push({name: 'Error'});
            } else {
                this.setupData();
            }
        },
        mounted() {
            //跳轉頁面時捲動至最上
            document.querySelector('.BigMain').scrollTo(0, 0);
        },
        methods: {
            // initForDataToken(item) {
            //     try {
            //         this.dataObject = this.$crypto.uriComponentToObject(item);
            //         if (this.$public.notNull(this.dataObject) &&
            //             this.dataObject.usedType === this.$route.name) {
            //             this.setupData();
            //         }
            //
            //     } catch (e) {
            //         this.$router.push({name: 'Error'});
            //         return false;
            //     }
            // },
            setupData: function () {
                this.isLoading = true
                this.$http.fetchWithEncrypt`GetArticleInfoByCode${{
                    'code': this.code,
                    'isAddViewCount': true,
                    'userToken': this.$auth.getAdminToken(),
                }}
                ${json => {
                    if(json.status) {
                        let data = json.data;
                        this.title = data.title;
                        this.content = data.content;
                        this.viewCount = data.viewCount;
                        this.titleImage = data.titleImage;
                        this.createdAt = data.createdAt;
                        this.messageList = data.messageList;
                        this.messageCount = data.messageCount;

                        this.id = data.id;
                        this.handleContent();
                    }
                    this.isLoading = false
                }}`
            },
            messageReply(obj) {
                this.isLoading = true
                this.$http.fetchWithAuth`ArticleReplyToReply${{
                    'id': this.id,
                    'replyId': parseInt(obj.id),
                    'replyContent': obj.message,
                }}
                ${json => {
                    this.isLoading = false
                    this.$public.showNotify(json.message, json.status);
                    if (json.status) {
                        this.setupData();
                    }
                }}`;
            },
            messageConfirm(message) {
                this.isLoading = true
                this.$http.fetchWithAuth`ArticleReply${{
                    'id': this.id,
                    'replyContent': message,
                }}
                ${json => {
                    this.isLoading = false
                    this.$public.showNotify(json.message, json.status);
                    if (json.status) {
                        this.setupData();
                    }
                }}`;
            },
            messageDelete(obj) {
                this.isLoading = true
                this.$http.fetchWithAuthEncrypt`DeleteArticleReply${{
                    'id': parseInt(obj.selectItem.id),
                }}
                ${json => {
                    this.isLoading = false
                    this.$public.showNotify(json.message, json.status);
                    if (json.status) {
                        this.setupData();
                    }
                }}`;
            },
            messageConfirmReport(obj) {
                this.isLoading = true
                this.$http.fetchWithAuthEncrypt`ReportArticleReply${{
                    'id': parseInt(obj.selectItem.id),
                    'reportType': parseInt(obj.radioReport),
                }}
                ${json => {
                    this.isLoading = false
                    this.$public.showNotify(json.message, json.status);
                }}`;
            },

            handleContent() {
                let self = this;

                self.$nextTick(() => {
                    Form.process(self.$refs.articleHtmlContentContainer)
                })
            },
        },

    }
</script>

<style lang="less" scoped src="../../less/complex.less"/>
<style lang="less" scoped>
    .main > img{
        @media(max-width: 1023px){
            margin: 0 -20px;
            width: calc( 100% + 40px);
        }
        @media(min-width: 1024px){
            height: 460px;
            object-fit: cover;
        }
    }
    h4{
        font-size: 24px;
        @media(min-width: 1024px){
            font-size: 35px;
        }
    }
    .date2{
        border-bottom: 1px solid var(--color-gray);
        padding-bottom: 10px;
        margin-bottom: 25px;
        @media(min-width: 1024px){
            font-size: 15px;
        }

    }
</style>
